import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getStylesObj } from '../../../../helpers/utils';
import MonitorContext from '../../MonitorContext';

export interface IMonitorFieldProps {
  field: string;
}

export default function MonitorField(props: IMonitorFieldProps) {
  const s80 = useSelector((state: any) => state.executor.s80);
  const context = useContext<any>(MonitorContext);
  const { monitorFields } = s80;
  const { field } = props;
  if (!monitorFields[`${context.monitor}_${field}`]) {
    return <div></div>;
  }

  const { value } = monitorFields[`${context.monitor}_${field}`];
  const styleObj = getStylesObj(monitorFields[`${context.monitor}_${field}`]);
  return <div style={{ ...styleObj, padding: '0 0 0 5px' }}>{value}</div>;
}
